import { render, staticRenderFns } from "./TrainingContent.vue?vue&type=template&id=38c37100&scoped=true&"
import script from "./TrainingContent.vue?vue&type=script&lang=js&"
export * from "./TrainingContent.vue?vue&type=script&lang=js&"
import style0 from "./TrainingContent.vue?vue&type=style&index=0&id=38c37100&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c37100",
  null
  
)

export default component.exports